import { Injectable } from '@angular/core';
import { Subject } from "rxjs/Subject";

@Injectable()
export class UserDetailService {

  // EventEmitter should not be used this way - only for `@Output()`s
  //nameChange: EventEmitter<string> = new EventEmitter<string>();
  onProfileUrlChange: Subject<string> = new Subject<string>();
  onCartDataChange: Subject<string> = new Subject<string>();

  constructor() {
   }

  onChange(profileUrl: string) {
    this.onProfileUrlChange.next(profileUrl);
  }

  onCartChange(cartData: string) {
    this.onCartDataChange.next(cartData);
  }

  updateStorage(field: string, value: string) {
    if (window.sessionStorage.getItem("userDetails") != null && window.sessionStorage.getItem("userDetails") != "null") {
      const ssUserDetails = JSON.parse(window.sessionStorage.getItem("userDetails"));
      ssUserDetails[field] = value;
      if(ssUserDetails != null && ssUserDetails != "null"){
        window.localStorage.setItem("userDetails", JSON.stringify(ssUserDetails));
      }
      else{
        window.localStorage.removeItem("userDetails");
      }
    }
   }

}



// WEBPACK FOOTER //
// ./src/app/feature/main/roles-shared/services/user-detail.service.ts